import React, { useState } from "react";
import {LanguageToggle} from "../../UI/ToggleButton/LanguageToggle";

const PrivacyPolicy = () => {
    const [lang, setLang] = useState("sv"); // default to Swedish

    const toggleLang = () => {
        setLang((prev) => (prev === "sv" ? "en" : "sv"));
    };

    const content = {
        sv: {
            title: "Integritetspolicy",
            effective: "Giltighetsdatum:",
            updated: "Senast uppdaterad:",
            intro: "Din integritet är viktig för oss. Denna integritetspolicy förklarar hur vi samlar in, använder och skyddar din information när du använder vår applikation (”Appen”).",
            sections: [
                {
                    heading: "Vilken information vi samlar in",
                    body: [
                        "Personlig information: namn, e-postadress, autentiseringstoken",
                        "Användningsdata: enhetsinformation och interaktioner",
                        "Cookies och funktionsanvänding mätningen"
                    ],
                },
                {
                    heading: "Hur vi använder din information",
                    body: "Vi använder informationen för att tillhandahålla och förbättra tjänsten, kommunicera med dig, samt uppfylla rättsliga krav.",
                },
                {
                    heading: "Dela och avslöja data",
                    body: "Vi säljer inte din information. Vi kan dela med betrodda tjänsteleverantörer när det krävs enligt lag.",
                },
                {
                    heading: "Dina rättigheter",
                    body: "Du har rätt att begära åtkomst till, rättelse av eller radering av din data genom att kontakta oss.",
                },
                {
                    heading: "Datasäkerhet",
                    body: "Vi skyddar din data med branschstandarder.",
                },
                {
                    heading: "Barns integritet",
                    body: "Appen är inte avsedd för barn under 13 år, och vi samlar inte medvetet in sådan information.",
                },
                {
                    heading: "Ändringar i denna policy",
                    body: "Vi kan uppdatera denna policy och publicerar alltid ändringarna här.",
                },
                {
                    heading: "Kontakta oss",
                    body: "Om du har frågor, du är välkommen att kontakta oss",
                },
            ],
        },
        en: {
            title: "Privacy Policy",
            effective: "Effective Date:",
            updated: "Last Updated:",
            intro: "Your privacy is important to us. This Privacy Policy explains how we collect, use, and safeguard your information when you use our application (the “App”).",
            sections: [
                {
                    heading: "Information We Collect",
                    body: [
                        "Personal Information: name, email, authentication tokens",
                        "Usage Data: device info and interactions",
                        "Cookies and Tracking Technologies"
                    ],
                },
                {
                    heading: "How We Use Your Information",
                    body: "We use the data to provide services, improve the app, communicate with you, and comply with laws.",
                },
                {
                    heading: "Data Sharing and Disclosure",
                    body: "We do not sell your data. We may share it with trusted providers if required by law.",
                },
                {
                    heading: "Your Rights and Choices",
                    body: "You may request access, correction, or deletion of your data by contacting us.",
                },
                {
                    heading: "Data Security",
                    body: "We protect your data using security best practices.",
                },
                {
                    heading: "Children’s Privacy",
                    body: "The App is not directed to children under 13, and we do not knowingly collect such data.",
                },
                {
                    heading: "Changes to This Policy",
                    body: "We may update this policy and will post changes here.",
                },
                {
                    heading: "Contact Us",
                    body: "If you have questions, don't hesitate to contact us.",
                },
            ],
        },
    };

    const data = content[lang];

    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh', overflowY: 'auto', padding: '2rem' }}>
            <div className='center pb-32' style={{ top: '4rem', zIndex: 10, maxWidth: 120}}>
                <LanguageToggle
                    toggle2={lang === 'en'}
                    handleToggleChange2={toggleLang}
                    lang={lang}
                    toggleLang={toggleLang}
                />
            </div>

            <div className='center' style={{ maxWidth: '800px', margin: '0 auto' }}>
                <h1 className="bold">{data.title}</h1>
                <p className="mb-16"><strong>{data.effective}</strong> 2027/05/01</p>
                <p className="mb-16"><strong>{data.updated}</strong> 2025/05/01</p>
                <p className="mb-16">{data.intro}</p>

                {data.sections.map((section, idx) => (
                    <div key={idx} className="left pt-16">
                        <h3>{section.heading}</h3>
                        {Array.isArray(section.body) ? (
                            <ul>
                                {section.body.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        ) : (
                            <p>{section.body}</p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PrivacyPolicy;
